// src/components/UserPermissionInitializer.jsx
// 現在ログイン中のユーザーを管理ユーザーに登録するコンポーネント

import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
    collection,
    addDoc,
    getDocs,
    query,
    where
} from 'firebase/firestore';
import { db } from '../services/firebase';
import { USER_ROLES, ADMIN_DEFAULT_PERMISSIONS } from '../types/permissions';

const UserPermissionInitializer = ({ accountId }) => {
    const { currentUser } = useAuth();
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const initializeUserPermissions = async () => {
        if (!currentUser || !accountId) {
            setMessage('ユーザー情報またはアカウントIDが不正です');
            return;
        }

        try {
            setLoading(true);
            setMessage('');

            // 既存ユーザーをチェック
            const usersRef = collection(db, 'accounts', accountId, 'users');
            const q = query(usersRef, where('uid', '==', currentUser.uid));
            const snapshot = await getDocs(q);

            if (!snapshot.empty) {
                setMessage('既にユーザー権限が設定されています');
                return;
            }

            // 新しいユーザーを管理ユーザーとして追加
            const userData = {
                uid: currentUser.uid,
                email: currentUser.email,
                displayName: currentUser.displayName || currentUser.email,
                role: USER_ROLES.ADMIN,
                permissions: ADMIN_DEFAULT_PERMISSIONS,
                joinedAt: new Date(),
                isActive: true,
                isOwner: true // 初期ユーザーはオーナーとして設定
            };

            await addDoc(usersRef, userData);

            setMessage('管理ユーザー権限を設定しました。ページをリロードしてください。');

            // 2秒後に自動リロード
            setTimeout(() => {
                window.location.reload();
            }, 2000);

        } catch (error) {
            console.error('権限初期化エラー:', error);
            setMessage('権限の設定に失敗しました: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="user-permission-initializer" style={{
            background: '#fff3cd',
            border: '1px solid #ffeeba',
            borderRadius: '8px',
            padding: '1rem',
            margin: '1rem 0'
        }}>
            <h3 style={{ color: '#856404', marginBottom: '0.5rem' }}>
                初回設定が必要です
            </h3>
            <p style={{ color: '#856404', marginBottom: '1rem' }}>
                ユーザー管理機能を使用するために、あなたを管理ユーザーとして登録する必要があります。
            </p>

            <button
                onClick={initializeUserPermissions}
                disabled={loading}
                style={{
                    background: '#007bff',
                    color: 'white',
                    border: 'none',
                    padding: '0.5rem 1rem',
                    borderRadius: '4px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    opacity: loading ? 0.6 : 1
                }}
            >
                {loading ? '設定中...' : '管理ユーザーとして登録'}
            </button>

            {message && (
                <div style={{
                    marginTop: '1rem',
                    padding: '0.5rem',
                    borderRadius: '4px',
                    background: message.includes('失敗') ? '#f8d7da' : '#d4edda',
                    color: message.includes('失敗') ? '#721c24' : '#155724',
                    border: `1px solid ${message.includes('失敗') ? '#f5c6cb' : '#c3e6cb'}`
                }}>
                    {message}
                </div>
            )}
        </div>
    );
};

export default UserPermissionInitializer;




